const generateCTAText = (data) => {
    if (data.eventStatus === 'previous') {
        if (data.tag && data.tag === 'Webinar') {
            return '<p class="card__cta-text">Watch on Demand</p>'
        } else {
            return '<p class="card__cta-text">Read More</p>'
        }
    } else {
        return '<p class="card__cta-text">Register Now</p>'
    }
}

// prettier-ignore
const template = (data) => `
    <div class="grid__item">
        <article class="card card--event card--row ${data.accent}">
            <a href="${data.url}" class="card__link">
                <div class="card__row">
                    <div class="card__shape-container">
                        <div class="card__shape"></div>
                        <div class="card__image-container">
                            ${data.image?.src ? `<img class="card__image" src="${data.image?.src}" alt="${data.image?.alt}" />` : ''}
                        </div>
                    </div>
                    <div class="card__container">
                        <div>
                            ${data.tag ? `<span class="tag">${data.tag}</span>` : ''}
                            ${data.eventStatus === 'previous' && data.tag === 'Webinar' ? '<span class="tag tag--dark">On-Demand</span>' : ''}
                        </div>
                        <h3 class="card__heading">${data.title}</h3>
                        <time class="card__description" datetime="2020-04">${data.date}</time>
                        <div class="card__cta card__cta--button">
                            ${generateCTAText(data)}
                        </div>
                    </div>
                </div>
            </a>
        </article>
    </div>
`
export default template
